import React from 'react';
import './OutstandingTasksModal.css';
import { format, dateg } from 'date-fns';
import { deleteNotification } from '../../modals';

const OutstandingTasksModal = ({ outstandingTasks, onClose, setShowAvialablityModal, removeOutstandingTasks, addMeetingSummary }) => {
  return (
    <div className="outstanding-tasks-modal">
      <div className="outstanding-tasks-content">
        <div className="outstanding-tasks-list">
          <div className="notification-container">
            {outstandingTasks.map((task, index) => {
              return task.type === 'Add Meeting Summary' ? <div className="notification-card">
                <div className="notification-header">
                  <span className="notification-message">
                    {task.name}
                    <div>
                      {format(new Date(...task.date.split('-').map((v, i) => i === 1 ? +v - 1 : +v)), 'MMMM dd, yyyy')}
                    </div>
                    <div>
                      {task.time}
                    </div>
                  </span>

                </div>
                <button className="action-button" onClick={() => {
                  addMeetingSummary(task.id, task.summaryAdded);

                }}>Add Meeting Summary</button>
              </div> :
                <div className="notification-card">
                  <div className="notification-header">
                    <span className="notification-message">
                      {task.message}
                    </span>
                    <button className="close-button" onClick={() => {
                      removeOutstandingTasks(index);
                      deleteNotification();
                    }}>×</button>

                  </div>
                  <button className="action-button" onClick={() => {
                    setShowAvialablityModal(true);
                    onClose();
                  }}>Set Availability</button>
                </div>
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutstandingTasksModal;